import { Box, Tooltip } from '@mui/material';
import { Check, PriorityHigh, RemoveCircleOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { getAllergenIcon } from '../../../../components/shared/AllergenChips';

export type MatrixAllergenStatus = 'Contains' | 'MayContain' | 'FreeFrom';

interface AllergenMatrixCellProps {
  allergenCode: string;
  status: MatrixAllergenStatus;
}

const statusStyle: Record<MatrixAllergenStatus, { color: string; bg: string; overlay: JSX.Element | null }> = {
  Contains: { color: '#B42318', bg: '#FEF3F2', overlay: null },
  MayContain: { color: '#B54708', bg: '#FFFAEB', overlay: <PriorityHigh sx={{ fontSize: 10 }} /> },
  FreeFrom: { color: '#027A48', bg: '#ECFDF3', overlay: <Check sx={{ fontSize: 10 }} /> },
};

/**
 * Compact per-cell indicator for the Public Menu allergen matrix (rows = recipes, columns = the
 * 14 UK/EU allergens) - a small circular icon rather than a full `AllergenChips` chip, which
 * would be too wide to lay out 14-across per row.
 */
const AllergenMatrixCell = ({ allergenCode, status }: AllergenMatrixCellProps) => {
  const { t } = useTranslation('publicMenu');
  const AllergenIcon = getAllergenIcon(allergenCode);
  const style = statusStyle[status];
  const label = t(`matrix.status.${status}`, status);

  return (
    <Tooltip title={`${allergenCode} - ${label}`}>
      <Box
        sx={{
          position: 'relative',
          width: 32,
          height: 32,
          mx: 'auto',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: style.bg,
          color: style.color,
        }}
      >
        {status === 'FreeFrom' ? (
          <RemoveCircleOutline sx={{ fontSize: 16 }} />
        ) : (
          <AllergenIcon sx={{ fontSize: 16 }} />
        )}
      </Box>
    </Tooltip>
  );
};

export default AllergenMatrixCell;
